import {
  Bell,
  Building2,
  CircuitBoard,
  Laptop,
  Palette,
  Settings as SettingsIcon,
  ShieldCheck,
  User,
  Users,
} from 'lucide-react';
import { SidebarTabs } from '@/components/sidebar-tabs';
import { PageHeader } from '@/components/page-header';
import { ProfileTab } from './settings/profile';
import { SecurityTab } from './settings/security';
import { TeamTab } from './settings/team';
import { AppearanceTab } from './settings/appearance';
import { BusinessTab } from './settings/business';
import { IntegrationsTab } from './settings/integrations';
import { SessionsTab } from './settings/sessions';
import { NotificationsTab } from './settings/notifications';

export function Settings() {
  return (
    <div className="space-y-5">
      <PageHeader icon={SettingsIcon} title="Settings" />

      <SidebarTabs
        paramName="tab"
        tabs={[
          { key: 'profile', label: 'Profile', icon: User, group: 'Account', content: <ProfileTab /> },
          { key: 'notifications', label: 'Notifications', icon: Bell, group: 'Account', content: <NotificationsTab /> },
          { key: 'appearance', label: 'Appearance', icon: Palette, group: 'Account', content: <AppearanceTab /> },
          { key: 'security', label: 'Security', icon: ShieldCheck, group: 'Account', content: <SecurityTab /> },
          { key: 'sessions', label: 'Sessions', icon: Laptop, group: 'Account', content: <SessionsTab /> },
          { key: 'business', label: 'Business', icon: Building2, group: 'Workspace', content: <BusinessTab /> },
          { key: 'team', label: 'Team', icon: Users, group: 'Workspace', content: <TeamTab /> },
          { key: 'integrations', label: 'Integrations', icon: CircuitBoard, group: 'Workspace', content: <IntegrationsTab /> },
        ]}
      />
    </div>
  );
}
